import React, {useEffect, useState, useContext} from 'react';
import {Pagination} from "antd";
import MsgsTable from "../components/msgsTable/MsgsTable";
import MsgsFilter from "../components/msgsTable/MsgsFilter";
import axios from "axios";
import {Link} from "react-router-dom";
import AxiosRequest, {AxiosRequestWithImba} from "../helpers/AxiosRequest";
import DeleteMsg from "../components/msgsTable/deleteMsg";
import {DeleteContext} from "../contexts/DeleteContext";

const MsgsTablePage = (props) => {
// data state to store the TV Maze API data. Its initial value is an empty array
    const {getDelete} = useContext(DeleteContext);
    
    let deleted = getDelete()
    const [msgs, setMsgs] = useState(null);
    const [total, setTotal] = useState(0);
    const [per, setPer] = useState(10);
    const [filters, setFilters] = useState({imba_id: props.match.params.imba_id, per_page: 10});
    const columns = [
        {
            title: 'id',
            dataIndex: 'id',
            key: 'id',
            render: text => <a>{text}</a>,
        },
        {
            title: 'User name',
            dataIndex: 'user',
            key: 'userName',
            render: user => <Link to={{
                pathname: `/${props.match.params.imba_id}/user/${user.remote_user_id}`
            }}>{user.login!='NULL' ? user.login: user.remote_user_id}</Link>,
        },
        {
            title: 'Room name',
            dataIndex: 'room',
            key: 'roomName',
            render: room => (room!=null) ? <Link to={{
                pathname: `/${props.match.params.imba_id}/room/${room.id}`
            }}>{room.name}</Link> : "Комната удалена"
        },
        {
            title: 'Message',
            dataIndex: 'message',
            key: 'messageText',
            render: text => <p>{text}</p>
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (text, record) => (
                <DeleteMsg msg={record} imba_id={props.match.params.imba_id}/>
            )
        }
    ];

    function onChangePage(page, size) {
        setFilters({
            ...filters,  //take existing key-value pairs and use them in our new state,
            page: page   //define new key-value pair with new uuid and [].
        })
    }
    function onChangeSize(current, size) {
        setFilters({
            ...filters.per_page = size,  //take existing key-value pairs and use them in our new state,
        })
    }
    // Using useEffect to call the API once mounted and set the data
    useEffect(() => {
        (async () => {
            AxiosRequest("imba_msgs_get", filters)
                .then((data) => {
                    console.log('tetasdasd')
                    setMsgs(data.data)
                    setTotal(data.total)
                    setPer(data.per_page)
                })
                .catch((error) =>{
                    window.location.href = `#/${props.match.params.imba_id}/signIn`
                });
        })();
    }, [filters,deleted]);

    const onChangeFilter = (values) => {
        values.imba_id = props.match.params.imba_id;
        values.per_page = per;
        setFilters(values)
    }
    return (
        <div className="App">
            <MsgsFilter onChange={onChangeFilter}/>
            <MsgsTable imba_id={props.match.params.imba_id} dataSource={msgs} columns={columns } total={total} per={per}/>
            <Pagination
                showSizeChanger
                className={'table-pagination'}
                onShowSizeChange={onChangeSize}
                defaultCurrent={1}
                PageSize={per}
                total={total}
                onChange={onChangePage}
            />
        </div>

    );
}

export default MsgsTablePage;